/**
 * The 422 payload returned when two automatic gifts target
 * overlapping patient profiles.
 */
export interface GiftConflictError {
    message: string;
    errors?: Record<string, string[]>;
    conflicting_gifts?: {
        id: number;
        name: string;
    }[];
}

/**
 * Read the conflict payload of a rejected gift write, if any.
 */
export function giftConflictOf(error: unknown): GiftConflictError | null {
    const response = (error as {response?: {status?: number, data?: GiftConflictError}})?.response;

    if (response?.status !== 422 || !response.data) {
        return null;
    }

    return response.data;
}
